import { render } from "./Settings.vue?vue&type=template&id=75324654&scoped=true&bindings={\"data\":\"setup\",\"call\":\"setup\"}"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=75324654&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75324654"

export default script